$(document).ready(function () {

   var url = window.location.href;
  var currentCategory = "";
  if (url.includes("activeCategory")) {
    currentCategory = url.split("?").pop().split("=").pop();
  } else {
    currentCategory = "all";
  }

  $(".story-landing-page .hero-banner." + currentCategory).removeClass("hide");
  $(".story-landing-page .story-category-tab ." + currentCategory).addClass("active");


  $(".story-landing-page .story-landing-wrapper ." + currentCategory).each(function (index) {
    if (index < 5) {
      $(this).removeClass("hide");
    }

    var total = $(".story-landing-page .story-landing-wrapper ." + currentCategory).length;

    if (total < 5) {
      $(".story-landing-page .story-btn .default-button").addClass("hide");
    } else {
      $(".story-landing-page .story-btn .default-button").removeClass("hide");
    }
  });

  if (currentCategory == "all") {
    $(".story-landing-page .story-landing-wrapper .category-item").each(function (index) {
      if (index < 5) {
        $(this).removeClass("hide");
      }
    });

    var total = $(".story-landing-page .story-landing-wrapper .category-item").length;

    if (total < 5) {
      $(".story-landing-page .story-btn .default-button").addClass("hide");
    } else {
      $(".story-landing-page .story-btn .default-button").removeClass("hide");
    }
  }

  //On Click event in Learn more Button of story landing page L 
  $(".story-landing-page .story-btn .default-button").on("click", function () {
    if (currentCategory == "all") {
      $(".story-landing-page .story-landing-wrapper .category-item").removeClass("hide");
    } else {
      $(".story-landing-page .story-landing-wrapper ." + currentCategory).removeClass("hide");
    }

    $(this).addClass("hide");
  });


  var abc = '<li class="font-category"><a class="nav-item "' + currentCategory + '" href="?activeCategory=' + currentCategory + '">' + currentCategory + '</a></li>';
  $(".story-landing-page .story-category-tab ul").prepend(abc);

  //For Mobile Device : 
  if ($(window).width() <= 768) {
    $(".story-category-tab .font-category").click(function () {
      $(this).closest('.story-category-tab').toggleClass('tab-accordion');
    });
  }


   $(".scrollbtn1").click(function(){
    
    $('html, body').animate(
             {scrollTop: 5000}, 
        'slow');    
    
    setTimeout(function(){       
       var list = $('.scrollbtn2');
			$('html, body').animate(
             {scrollTop: list.offset().top}, 
             'slow');    
   	 }, 700);       
    
	});
  

});